import { RootState } from '../types'

export const getGridSelector = (state: RootState) => state.grid
